import { render, staticRenderFns } from "./scene5.vue?vue&type=template&id=6c6cb21b&scoped=true&"
import script from "./scene5.vue?vue&type=script&lang=ts&"
export * from "./scene5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6cb21b",
  null
  
)

export default component.exports